import { Box, Button, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MoneyClipboard from "../../../../components/Vectors/MoneyChipboard";
import { DelendButton } from "../../../../components/Buttons";

const ContractConfirmation = ({ openSignModal }) => {
  let navigate = useNavigate();

  const handleSignCashAdvance = async () => {
    openSignModal(true);
  };

  return (
    <Box
      display={"flex"}
      alignContent={"center"}
      justifyContent={"center"}
      sx={{
        border: "1px solid grey",
        borderRadius: "8px",
        borderColor: "#E9EBF0",
      }}
    >
      <Grid container padding={"32px 24px"} spacing={2}>
        <Grid item xs={12}>
          <MoneyClipboard />
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant="body2"
            textAlign={"justify"}
            sx={{
              fontWeight: 400,
              color: "#00010C",
            }}
          >
            Para aproveitar os benefícios de crédito da ACCredito-SCD, pressione
            o botão "Contratar", leia atentamente o Contrato de Antecipação a
            Fornecedores, declare que concordou com as condições estabelecidas e
            pressione o botão "Concordar" para realizar a contratação.
          </Typography>
        </Grid>
        <Grid item container xs={12}>
          <Grid item xs={12}>
            <Box
              display={"flex"}
              justifyContent={"end"}
              padding={"32px 0 0 0"}
              alignItems={"center"}
            >
              <Button
                onClick={() => navigate("/dashboard/receivable")}
                variant="outlined"
                sx={{
                  textTransform: "none",
                  borderRadius: 50,
                  mr: "24px",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: 14,
                  }}
                  color="inherit"
                  noWrap
                >
                  Cancelar
                </Typography>
              </Button>

              <DelendButton
                text={"Contratar"}
                onClick={handleSignCashAdvance}
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContractConfirmation;